// extracted by mini-css-extract-plugin
export var messageSideLeft = "_kb-1";
export var messageSideRight = "_kb-2";
export var orderLookupBubbleContainer = "_kb-0";
export var submitButton = "_kb-3";